import type { Hat, Role } from '@proteam/shared';

import type { IconName } from '../ui/index.js';

export interface NavItem {
  to: string;
  label: string;
  icon: IconName;
}

/**
 * The nav items shown per role in the top bar (desktop) and the bottom tab bar
 * (phones). Kept as the fallback for a signed-in user before a hat resolves.
 */
const NAV_BY_ROLE: Record<Role, NavItem[]> = {
  student: [
    { to: '/build', label: 'Build', icon: 'build' },
    { to: '/showcase', label: 'Explore', icon: 'gallery' },
  ],
  parent: [
    { to: '/parent', label: 'Home', icon: 'home' },
    { to: '/showcase', label: 'Explore', icon: 'gallery' },
  ],
  mentor: [
    { to: '/mentor', label: 'Dashboard', icon: 'dashboard' },
    { to: '/showcase', label: 'Explore', icon: 'gallery' },
  ],
};

export function navForRole(role: Role): NavItem[] {
  return NAV_BY_ROLE[role];
}

/**
 * The nav items for the currently active hat. Switching hats re-scopes these so
 * the whole shell moves to that surface (SPEC.md "One person, multiple hats").
 * The showcase stays reachable from every hat.
 */
const NAV_BY_HAT: Record<Hat, NavItem[]> = {
  projects: [
    { to: '/build', label: 'Build', icon: 'build' },
    { to: '/showcase', label: 'Explore', icon: 'gallery' },
  ],
  students: [
    { to: '/mentor', label: 'Dashboard', icon: 'dashboard' },
    { to: '/showcase', label: 'Explore', icon: 'gallery' },
  ],
  kids: [
    { to: '/parent', label: 'Home', icon: 'home' },
    { to: '/showcase', label: 'Explore', icon: 'gallery' },
  ],
};

export function navForHat(hat: Hat): NavItem[] {
  return NAV_BY_HAT[hat];
}
